import WarrantyListPanelComponent from "./warrantyListPanel.container";

export default WarrantyListPanelComponent;
